// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  padding-top: 30px;
  display: none;
  position: absolute;
  background-color: #b2b6b8;
  /* 0 0 5px #63a8be;; */
  min-width: 160px;
  border-radius: 15px;
  /* background-color: #232323; */
}

.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  color: white;
}

.dropdown-content a:hover {
  background-color: #63a8be;
  border-radius: 15px;
}

/* Relies on the dependency of header in ../navbar.css */
.header ul li:hover .dropdown-content {
  display: block;
}

.dropdown-list {
  text-align: center;
  /* display: inline-block; */
  list-style: none;
  margin: 0 auto;
  display: flex;
  /* padding: 20px; */
  margin-right: 20px;
  justify-content: space-evenly;
}

.dropdown-list > li {
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/dropdowns/Dropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-content {\n  padding-top: 30px;\n  display: none;\n  position: absolute;\n  background-color: #b2b6b8;\n  /* 0 0 5px #63a8be;; */\n  min-width: 160px;\n  border-radius: 15px;\n  /* background-color: #232323; */\n}\n\n.dropdown-content a {\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n  color: white;\n}\n\n.dropdown-content a:hover {\n  background-color: #63a8be;\n  border-radius: 15px;\n}\n\n/* Relies on the dependency of header in ../navbar.css */\n.header ul li:hover .dropdown-content {\n  display: block;\n}\n\n.dropdown-list {\n  text-align: center;\n  /* display: inline-block; */\n  list-style: none;\n  margin: 0 auto;\n  display: flex;\n  /* padding: 20px; */\n  margin-right: 20px;\n  justify-content: space-evenly;\n}\n\n.dropdown-list > li {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
